import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import {
    APP_INITIALIZER,
    ApplicationConfig,
    provideBrowserGlobalErrorListeners,
    provideZonelessChangeDetection,
} from '@angular/core';
import { provideClientHydration, withIncrementalHydration } from '@angular/platform-browser';
import { provideRouter, withInMemoryScrolling, withViewTransitions } from '@angular/router';
import { BreadcrumbService } from '@shared/breadcrumbs/breadcrumbs.service';
import { CurrentRouteService } from '@shared/current-route/current-route.service';
import { GetStartedService } from '@shared/get-started/get-started.service';
import { IpInfoService } from '@shared/ip-info/ip-info.service';
import { ModalService } from '@shared/modal/modal.service';
import { RecaptchaInterceptor } from '@shared/recaptcha/recaptcha.interceptor';
import { RecaptchaService } from '@shared/recaptcha/recaptcha.service';
import { provideNgxMask } from 'ngx-mask';
import { EMPTY } from 'rxjs';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
    providers: [
        provideZonelessChangeDetection(),
        provideBrowserGlobalErrorListeners(),
        provideClientHydration(withIncrementalHydration()),
        provideHttpClient(withFetch(), withInterceptors([RecaptchaInterceptor])),
        provideNgxMask(),
        provideRouter(
            routes,
            withViewTransitions({ skipInitialTransition: true }),
            withInMemoryScrolling({
                scrollPositionRestoration: 'top',
                anchorScrolling: 'enabled',
            }),
        ),

        {
            provide: APP_INITIALIZER,
            useFactory: () => () => EMPTY,
            multi: true,
        },
        CurrentRouteService,
        ModalService,
        GetStartedService,
        RecaptchaService,
        BreadcrumbService,
        IpInfoService,
    ],
};
